/**
 * @property {string} code
 * @property {string} [errorId]
 * @property {string} [message]
 */
export class ErrorResponse {
  constructor(err, status) {
    if (err && status !== 401) {
      if (err.error) {
        err = err.error;
      }
      if (err.errorId) {
        this.code = err.code || err;
        this.errorId = err.errorId;
        this.message = err.message || undefined;
        if (this.message && this.message.length > 255) {
          this.message = this.message.substring(0, 255) + '...';
        }
      }
    } else {
      this.code = `HTTP_ERROR_${status}`;
    }
  }
}
